import { Pencil } from '@phosphor-icons/react/dist/ssr/Pencil'
import { Money } from '@phosphor-icons/react/dist/ssr/Money'
import { DotsThreeCircle } from '@phosphor-icons/react/dist/ssr/DotsThreeCircle'
import { XCircle } from '@phosphor-icons/react/dist/ssr/XCircle'
import { X } from '@phosphor-icons/react/dist/ssr/X'
import { CheckCircle } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { ListBullets } from '@phosphor-icons/react/dist/ssr/ListBullets'
import { StopCircle } from '@phosphor-icons/react/dist/ssr/StopCircle'
import { SealPercent } from '@phosphor-icons/react/dist/ssr/SealPercent'
import { Briefcase } from '@phosphor-icons/react/dist/ssr/Briefcase'
import { UsersThree } from '@phosphor-icons/react/dist/ssr/UsersThree'
import { User } from '@phosphor-icons/react/dist/ssr/User'
import { ChatCenteredText } from '@phosphor-icons/react/dist/ssr/ChatCenteredText'
import { Question } from '@phosphor-icons/react/dist/ssr/Question'
import { Eye } from '@phosphor-icons/react/dist/ssr/Eye'
import { EyeSlash } from '@phosphor-icons/react/dist/ssr/EyeSlash'
import { PencilSimple } from '@phosphor-icons/react/dist/ssr/PencilSimple'
import { House } from '@phosphor-icons/react/dist/ssr/House'
import { Bell } from '@phosphor-icons/react/dist/ssr/Bell'
import { ShoppingCartSimple } from '@phosphor-icons/react/dist/ssr/ShoppingCartSimple'
import { Storefront } from '@phosphor-icons/react/dist/ssr/Storefront'
import { MapPin } from '@phosphor-icons/react/dist/ssr/MapPin'
import { Shapes } from '@phosphor-icons/react/dist/ssr/Shapes'
import { Envelope } from '@phosphor-icons/react/dist/ssr/Envelope'
import { PlusMinus } from '@phosphor-icons/react/dist/ssr/PlusMinus'
import { Plus } from '@phosphor-icons/react/dist/ssr/Plus'
import { PencilSimpleLine } from '@phosphor-icons/react/dist/ssr/PencilSimpleLine'
import { TrendUp } from '@phosphor-icons/react/dist/ssr/TrendUp'
import { VectorTwo } from '@phosphor-icons/react/dist/ssr/VectorTwo'
import { ThumbsUp } from '@phosphor-icons/react/dist/ssr/ThumbsUp'
import { ThumbsDown } from '@phosphor-icons/react/dist/ssr/ThumbsDown'
import { Cube } from '@phosphor-icons/react/dist/ssr/Cube'
import { ArrowClockwise } from '@phosphor-icons/react/dist/ssr/ArrowClockwise'
import { TagSimple } from '@phosphor-icons/react/dist/ssr/TagSimple'
import { Path } from '@phosphor-icons/react/dist/ssr/Path'
import { Ruler } from '@phosphor-icons/react/dist/ssr/Ruler'
import { Sparkle } from '@phosphor-icons/react/dist/ssr/Sparkle'
import { Rows } from '@phosphor-icons/react/dist/ssr/Rows'
import { CheckSquareOffset } from '@phosphor-icons/react/dist/ssr/CheckSquareOffset'
import { EnvelopeOpen } from '@phosphor-icons/react/dist/ssr/EnvelopeOpen'
import { Check } from '@phosphor-icons/react/dist/ssr/Check'
import { Signature } from '@phosphor-icons/react/dist/ssr/Signature'
import { FileX } from '@phosphor-icons/react/dist/ssr/FileX'
import { ArrowsLeftRight } from '@phosphor-icons/react/dist/ssr/ArrowsLeftRight'
import { BuildingOffice } from '@phosphor-icons/react/dist/ssr/BuildingOffice'
import { FileArrowDown } from '@phosphor-icons/react/dist/ssr/FileArrowDown'
import { FileText } from '@phosphor-icons/react/dist/ssr/FileText'
import { Files } from '@phosphor-icons/react/dist/ssr/Files'
import { GearSix } from '@phosphor-icons/react/dist/ssr/GearSix'
import { HouseSimple } from '@phosphor-icons/react/dist/ssr/HouseSimple'
import { IdentificationCard } from '@phosphor-icons/react/dist/ssr/IdentificationCard'
import { MagnifyingGlass } from '@phosphor-icons/react/dist/ssr/MagnifyingGlass'
import { PencilLine } from '@phosphor-icons/react/dist/ssr/PencilLine'
import { Receipt } from '@phosphor-icons/react/dist/ssr/Receipt'
import { SignOut } from '@phosphor-icons/react/dist/ssr/SignOut'
import { Star } from '@phosphor-icons/react/dist/ssr/Star'
import { Users } from '@phosphor-icons/react/dist/ssr/Users'
import { Table } from '@phosphor-icons/react/dist/ssr/Table'
import { Tag } from '@phosphor-icons/react/dist/ssr/Tag'
import { ArrowSquareOut } from '@phosphor-icons/react/dist/ssr/ArrowSquareOut'
import { Palette } from '@phosphor-icons/react/dist/ssr/Palette'
import { Barbell } from '@phosphor-icons/react/dist/ssr/Barbell'
import { Stack } from '@phosphor-icons/react/dist/ssr/Stack'
import { Queue } from '@phosphor-icons/react/dist/ssr/Queue'
import { Link } from '@phosphor-icons/react/dist/ssr/Link'
import { NotePencil } from '@phosphor-icons/react/dist/ssr/NotePencil'
import { CalendarDots } from '@phosphor-icons/react/dist/ssr/CalendarDots'
import { Wrench } from '@phosphor-icons/react/dist/ssr/Wrench'
import { Warning } from '@phosphor-icons/react/dist/ssr/Warning'
import { CurrencyEur } from '@phosphor-icons/react/dist/ssr/CurrencyEur'
import { Paragraph } from '@phosphor-icons/react/dist/ssr/Paragraph'
import { WarningCircle } from '@phosphor-icons/react/dist/ssr/WarningCircle'

const components = {
  ArrowClockwise,
  Bell,
  Briefcase,
  Barbell,
  BuildingOffice,
  ChatCenteredText,
  Check,
  CheckCircle,
  CheckSquareOffset,
  CalendarDots,
  Cube,
  CurrencyEur,
  DotsThreeCircle,
  Envelope,
  EnvelopeOpen,
  Eye,
  EyeSlash,
  FileArrowDown,
  Files,
  FileText,
  FileX,
  GearSix,
  HouseSimple,
  House,
  IdentificationCard,
  ListBullets,
  MagnifyingGlass,
  MapPin,
  Money,
  Path,
  Pencil,
  PencilLine,
  PencilSimple,
  PencilSimpleLine,
  PlusMinus,
  Plus,
  Paragraph,
  Question,
  Receipt,
  Rows,
  Ruler,
  SealPercent,
  Shapes,
  ShoppingCartSimple,
  Signature,
  SignOut,
  Star,
  Sparkle,
  StopCircle,
  Storefront,
  Stack,
  Table,
  Tag,
  TagSimple,
  ThumbsDown,
  ThumbsUp,
  TrendUp,
  User,
  Users,
  UsersThree,
  VectorTwo,
  X,
  XCircle,
  ArrowSquareOut,
  Palette,
  Queue,
  Link,
  NotePencil,
  Wrench,
  Warning,
  ArrowsLeftRight,
  WarningCircle,
}

export type DynamicIconName = string

export type DynamicIconProps = {
  name: DynamicIconName
  className?: string
  onClick?: () => void
  weight?: 'bold' | 'duotone' | 'fill' | 'light' | 'regular' | 'thin'
  alt?: string
}

export const DynamicIcon = (props: DynamicIconProps) => {
  const { name, className, weight, onClick, alt, ...rest } = props

  const Icon = components[name] || Question

  return (
    <Icon
      className={className}
      onClick={onClick}
      weight={weight}
      alt={alt}
      {...rest}
    />
  )
}
